import React from 'react';
import { Box, Container, Typography, Grid, Paper, Avatar, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

const AboutPage = () => {
    return (
        <Box>
            {/* Hero Section */}
            <Box sx={{
                bgcolor: 'primary.main',
                color: 'white',
                py: { xs: 8, md: 12 },
                textAlign: 'center'
            }}>
                <Container maxWidth="md">
                    <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 800 }}>
                        Helping You Unlock Your Child's Genius
                    </Typography>
                    <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '800px', mx: 'auto' }}>
                        Bridging the gap between traditional learning and cognitive potential.
                    </Typography>
                </Container>
            </Box>

            {/* Bio Section */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            {/* Placeholder for Photo */}
                            <Avatar
                                sx={{
                                    width: 300,
                                    height: 300,
                                    bgcolor: 'grey.300',
                                    fontSize: '3rem',
                                    color: 'grey.600'
                                }}
                            >
                                Photo
                            </Avatar>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: 'primary.dark' }}>
                            Hi, I’m Ashwathy Nair
                        </Typography>
                        <Typography variant="h6" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
                            Technology Lead turned Early Education Specialist
                        </Typography>
                        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                            With an MCA degree and a background leading software teams, I understand the skills the next generation needs to thrive. Today, I combine that strategic thinking with my passion for teaching. I am a Montessori Certified Guide and a Right Brain Education Coach dedicated to the 3–6 age group.
                        </Typography>
                        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                            I believe every child has a "silent genius" waiting to be nurtured. Whether you are a parent looking for guidance or an educator seeking new perspectives, I am here to help you navigate the beautiful journey of early education.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            {/* Stats Section */}
            <Box sx={{ bgcolor: 'secondary.light', py: 8 }}>
                <Container maxWidth="lg">
                    <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 700, mb: 6 }}>
                        By the Numbers
                    </Typography>
                    <Grid container spacing={4} justifyContent="center">
                        {[
                            { count: '4+', label: 'Years of Dedicated Teaching', icon: <SchoolIcon fontSize="large" /> },
                            { count: '100+', label: 'Parents Trained in Right Brain Education', icon: <GroupsIcon fontSize="large" /> },
                            { count: 'Certified', label: 'Expertise in Montessori Methodology (3–6)', icon: <EmojiObjectsIcon fontSize="large" /> },
                        ].map((stat, index) => (
                            <Grid item xs={12} md={4} key={index}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: 4,
                                        textAlign: 'center',
                                        height: '100%',
                                        borderRadius: 4,
                                        transition: 'transform 0.2s',
                                        '&:hover': { transform: 'translateY(-5px)' }
                                    }}
                                >
                                    <Box sx={{ color: 'primary.main', mb: 2 }}>
                                        {stat.icon}
                                    </Box>
                                    <Typography variant="h3" gutterBottom sx={{ fontWeight: 800, color: 'secondary.main' }}>
                                        {stat.count}
                                    </Typography>
                                    <Typography variant="h6" color="text.secondary">
                                        {stat.label}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Closing Section */}
            <Box sx={{ py: 10, textAlign: 'center' }}>
                <Container maxWidth="md">
                    <AutoAwesomeIcon color="secondary" sx={{ fontSize: 60, mb: 2 }} />
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                        "The goal of early childhood education should be to activate the child's own natural desire to learn."
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        - Maria Montessori
                    </Typography>
                </Container>
            </Box>
        </Box>
    );
};

export default AboutPage;
